import { getModels } from "@/lib/data";

export async function GET() {
  const models = getModels();
  return Response.json(models);
}
